import { MESSAGES_BY_LOCALE } from '../locale/translations';
import isBrowser from '../utils/isBrowser';
var useLocaleData = function (defaultLocale, locale) {
    if (defaultLocale === void 0) { defaultLocale = 'en'; }
    // If a locale was passed via props, use it or the defaultLocale as the default returned value
    var fallbackLocale = (locale ||
        defaultLocale);
    var output = {
        data: MESSAGES_BY_LOCALE[fallbackLocale],
        locale: fallbackLocale,
    };
    // Use the browser's navigator.language if no locale was provided via props
    if (!locale && isBrowser()) {
        var language_1 = navigator.language;
        var selectedLocale = Object.keys(MESSAGES_BY_LOCALE).find(function (key) {
            return language_1.startsWith(key);
        });
        if (selectedLocale) {
            output.locale = selectedLocale;
            output.data = MESSAGES_BY_LOCALE[selectedLocale];
        }
    }
    return output;
};
export default useLocaleData;
